import { render, staticRenderFns } from "./bigImage.vue?vue&type=template&id=dd5cfa9c&scoped=true&"
import script from "./bigImage.vue?vue&type=script&lang=js&"
export * from "./bigImage.vue?vue&type=script&lang=js&"
import style0 from "./bigImage.vue?vue&type=style&index=0&id=dd5cfa9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5cfa9c",
  null
  
)

component.options.__file = "bigImage.vue"
export default component.exports